export default status => {
  if (status === 'LINKED') {
    return '#EAEBFF';
  } if (status === 'UNLINKED') {
    return '#FFEDCC';
  } return '#FFEDCC';
};
